import * as React from "react";
import styled from "styled-components";
import { Field as FormikField } from "formik";
import { lighten } from "polished";

import Grid from "../Hedron";
import { WysiwygEditor } from "../WysiwygEditor";
import { IFormTextArea } from ".";
import FieldError from "./FieldError";
import Label from "./Label";
import { InputCss } from "./Input";

const TextAreaStyled = styled(FormikField)`
  min-height: 160px;
  font-size: ${({ theme }) => theme.fonts.sizes.p};
  outline: none;
  ${InputCss}

  &:hover {
    border-color: ${({ theme }) => theme.colors.lightGrey};
    background-color: ${({ theme }) => theme.colors.white};
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.primaryLight};
    background-color: ${({ theme }) => theme.colors.white};
  }

  &.error {
    border-color: ${({ theme }) => theme.colors.error};

    &:hover {
      border-color: ${({ theme }) => theme.colors.error};
      background-color: ${({ theme }) => theme.colors.errorLight};
    }

    &:focus {
      border-color: ${({ theme }) => theme.colors.error};
      background-color: ${({ theme }) => theme.colors.errorLight};
    }
  }

  transition: ${({ theme }) => theme.transition};
  color: ${({ theme }) => theme.fonts.colors.primary};
  font-size: ${({ theme }) => theme.fonts.sizes.p};
  line-height: 1.2em;
  background: ${({ theme }) => theme.colors.white};
  border: 2px solid ${({ theme }) => theme.colors.lightestGrey};
  border-radius: ${({ theme }) => theme.borderRadius};

  &:disabled {
    color: ${({ theme }) => lighten(0.03, theme.colors.lightGrey)};

    &:hover {
      cursor: not-allowed;
    }
  }
`;

const TextArea = React.forwardRef<unknown, IFormTextArea>(({
  autoHideLabels, label, error, disabled, name, handleChange, as, value, wysiwyg, setFieldValue, validation
}, ref) => {
  return (
    <>
      {!autoHideLabels && (
        <Grid.Box>
          <Label
            for={name}
            label={label}
            required={validation?._exclusive?.required}
          />
        </Grid.Box>
      )}

      <Grid.Box>
        {wysiwyg ? (
          <WsywyigWrapper className={error && error.length ? "errors" : ""}>
            <WysiwygEditor
              frame
              handleChange={value => setFieldValue ? setFieldValue(name, value) : null}
              initalValue={value as string}
            />
          </WsywyigWrapper>
        ) : (
          <TextAreaStyled
            ref={ref}
            component="textarea"
            disabled={disabled}
            className={error && error.length > 0 ? "error" : undefined}
            id={name}
            name={name}
            onChange={handleChange}
            // @ts-ignore
            as={as}
            value={value}
          />
        )}
      </Grid.Box>

      {error && (
        <Grid.Box>
          <FieldError>
            {error}
          </FieldError>
        </Grid.Box>
      )}
    </>
  );
});

const WsywyigWrapper = styled(Grid.Box)`
  margin: 0 0 10px 0;

  &.errors {
    .frame {
      border-color: ${({ theme }) => theme.colors.error};
    }
    span {
      color: ${({ theme }) => theme.colors.error};
    }
  }
`;

export default TextArea;
